export const MOBILE_LINE = 'mobile_line'
export const RESIDENTIAL = 'residential'
export const PRO = 'pro'
export const MAIN_LINE = 'main_line'
export const CONSUMER = 'Consumer'
export const COMPANY = 'Company'
export const ADDITIONAL_LINE = 'additional_line'
